// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { Injectable } from '@angular/core';
import { StatePersister } from '../../services/state-persister';
import * as fromAgent from '../agent.reducer';

@Injectable({
  providedIn: 'root'
})
export class AgentPersisterService extends StatePersister<fromAgent.State> {
  constructor() {
    super(sessionStorage, fromAgent.featureKey);
  }
}
